interface Boolean {
  toYesNo(): string;
}

Boolean.prototype.toYesNo = function() {
  return this ? 'Yes' : 'No';
};
